var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoHall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4475 36.253V45.3674H29.0881V38.4067M29.0881 14.2149V12.3463C29.0881 11.3661 28.2735 10.5723 27.2678 10.5723C26.2621 10.5723 25.4475 11.3661 25.4475 12.3463M17.67 45.3674H32.2984M34.2831 17.379H22.0568M29.0977 20.2798H20.9112M32.9934 30.1486H17.1959M25.3739 33.0504H17.1874M28.5031 33.0504H34.9878M34.6568 45.3674H36.744M25.4475 27.4246V23.2441M29.0881 27.4246V23.2441M19.2735 23.2441H38.4063C39.1664 23.2441 39.7824 22.6437 39.7824 21.9029V15.7558C39.7824 15.015 39.1664 14.4147 38.4063 14.4147H19.2735C18.9554 14.4147 18.6511 14.5395 18.428 14.7601L14.9155 18.2467C14.5899 18.5693 14.5899 19.0874 14.9155 19.41L18.428 22.8965C18.6511 23.1171 18.9554 23.242 19.2735 23.242V23.2441ZM37.787 36.253H15.0265C14.2664 36.253 13.6504 35.6526 13.6504 34.9118V28.7648C13.6504 28.0239 14.2664 27.4236 15.0265 27.4236H37.787C38.1052 27.4236 38.4095 27.5485 38.6326 27.769L42.1451 31.2556C42.4707 31.5782 42.4707 32.0963 42.1451 32.4189L38.6326 35.9054C38.4095 36.126 38.1052 36.2509 37.787 36.2509V36.253Z",
    stroke: "#878686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoHall);
export default __webpack_public_path__ + "static/media/expo-hall.3e28f19d712709dfcb27a62db6cd7aba.svg";
export { ForwardRef as ReactComponent };